function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 14.4998V13.5C10.5 12.6716 11.1716 12 12 12V12C12.8284 12 13.5 12.6716 13.5 13.5V14.5M4.5 14.4998V13.5C4.5 12.6716 5.17157 12 6 12C6.82843 12 7.5 12.6716 7.5 13.5V14.5M7.5 8.5C7.5 9.32843 6.82843 10 6 10C5.17157 10 4.5 9.32843 4.5 8.5C4.5 7.67157 5.17157 7 6 7C6.82843 7 7.5 7.67157 7.5 8.5ZM13.5 8.5C13.5 9.32843 12.8284 10 12 10C11.1716 10 10.5 9.32843 10.5 8.5C10.5 7.67157 11.1716 7 12 7C12.8284 7 13.5 7.67157 13.5 8.5ZM16.5 4.5C16.5 5.32843 15.8284 6 15 6C14.1716 6 13.5 5.32843 13.5 4.5C13.5 3.67157 14.1716 3 15 3C15.8284 3 16.5 3.67157 16.5 4.5ZM10.5 4.5C10.5 5.32843 9.82843 6 9 6C8.17157 6 7.5 5.32843 7.5 4.5C7.5 3.67157 8.17157 3 9 3C9.82843 3 10.5 3.67157 10.5 4.5ZM4.5 4.5C4.5 5.32843 3.82843 6 3 6C2.17157 6 1.5 5.32843 1.5 4.5C1.5 3.67157 2.17157 3 3 3C3.82843 3 4.5 3.67157 4.5 4.5Z",
  stroke: "#757575",
  strokeWidth: 1.4,
  strokeLinecap: "round"
});

function SvgDaxCrowd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaxCrowd);
export default __webpack_public_path__ + "static/media/dax-crowd.5ce1be2a.svg";
export { ForwardRef as ReactComponent };